import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0f1997f3&"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports